export default {
	visitorDetails: '/visitor/detail/{id}', //访客公司详情
	visitorDetailList: '/visitor/detailpage', //访问详情列表
	visitorDataStats: '/visitor/statistics', // 数据统计
	visitorList: '/visitor/list', // 数据列表
	dataExport: '/visitor/downlistinquiry', // 数据导出
	visitorStaff: '/visitor/visitorstaff', //访客联系人数量
	visitorStaffList: '/visitor/visitorstaffpage', //访客联系人列表
	visitorStaffTotal: '/visitor/visitorstaffnum', //访客公司员工统计数
};
